import Input from 'src/components/Input/Input';
import React from 'react';
import { useAppDispatch, useAppSelector } from 'src/store';
import { setDateRangeY } from 'src/store/slices/analyticSlices';
import type { AxisGroupOption } from 'src/pages/AnalyticsPage/AnalyticsCustomer/AnalyticsCoCustomer.types';

export const SelectDateYAxis = ({ selectOptions }: { selectOptions: AxisGroupOption[] }) => {
  const dispatch = useAppDispatch();
  const { dateY } = useAppSelector((s) => s.analyticSlices);
  const defaultValue = dateY
    ? selectOptions.find((option) => option.groupBy === dateY)
    : selectOptions[1];
  const [selectValue, setSelectValue] = React.useState(defaultValue);

  const handleDateChange = (e: AxisGroupOption) => {
    dispatch(
      setDateRangeY({
        dateY: e.groupBy,
      }),
    );
    setSelectValue(e);
  };
  return (
    <div className={'input-container text-[.88rem] min-w-[140px] analytic-date'}>
      <Input
        type={'select'}
        selectOptions={selectOptions}
        value={selectValue}
        dropdownClassName={'!py-1'}
        // Input reports back one of selectOptions, so it is an AxisGroupOption.
        onChange={(e) => {
          handleDateChange(e as AxisGroupOption);
        }}
      />
    </div>
  );
};
